import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import api from "@/lib/api";

// Slim, dynamic promo bar for public pages. Reads the active auto promo and
// self-hides when there's none — so it always matches what admins set.
export function PromoRibbon({ className = "" }) {
  const [promo, setPromo] = useState(null);

  useEffect(() => {
    api.get("/billing/promotions/active")
      .then(({ data }) => {
        const list = data || [];
        const annual = list.find((p) => !p.plan_lookup_keys.length || p.plan_lookup_keys.some((k) => k.endsWith("annual")));
        setPromo(annual || null);
      })
      .catch(() => {});
  }, []);

  if (!promo) return null;
  const off = promo.discount_type === "percent" ? `${promo.value}% off` : `$${promo.value} off`;
  const dur = promo.duration === "once" ? "your first year" : promo.duration === "forever" ? "every year" : `${promo.duration_in_months} months`;

  return (
    <div className={`w-full bg-gradient-to-r from-[#1a3060] to-[#2c6aa8] text-white ${className}`} data-testid="promo-ribbon">
      <div className="max-w-4xl mx-auto px-6 py-2 flex items-center justify-center gap-2 text-center">
        <Sparkles className="h-4 w-4 text-[#F0B429] shrink-0" strokeWidth={2} />
        <p className="text-[13px] sm:text-sm font-medium">
          <span className="font-bold">Limited time:</span> {off} annual plans — save on {dur}
          {promo.ends_at ? ` · ends ${new Date(promo.ends_at).toLocaleDateString()}` : ""}
        </p>
      </div>
    </div>
  );
}
